import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { Lazyload } from 'vant'
import { initAppTheme } from '@/theme/appTheme'

// 全局样式
import './assets/css/index.less'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/image-preview/style'

// REM 自适应（替代 Nuxt rem.client.ts plugin）
import './plugins/rem'

initAppTheme()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(Lazyload)  // 注册 v-lazy 图片懒加载指令

app.mount('#app')

